module.exports = __webpack_public_path__ + "static/media/chess-bishop-alt.91138741.svg";